<div class="ap-selector-modal__controls">
    <ap-icon-button-link iconName="checkmark" (onClick)="selectAll()" iconSize="medium" data-testid="select-all">
        {{ 'selectorModal.select.all' | apContent: { amount: options()?.length.toString() || '0' } }}
    </ap-icon-button-link>
    <ap-icon-button-link iconName="close" (onClick)="deselectAll()" iconSize="medium" data-testid="deselect-all">
        {{ 'selectorModal.select.none' | apContent: { amount: selectedOptions()?.length.toString() || '0' } }}
    </ap-icon-button-link>
</div>

<ng-template #optionTemplate let-option>
    <ap-checkbox
        data-testid="option"
        (change)="onChange($event, option)"
        [formControl]="getFormControl(option.id)"
        [attr.data-id]="option.id"
    >
        <span
            class="ap-selector-modal__option"
            [ngClass]="{ 'ap-selector-modal__option--currency': option?.template === 'currency' }"
            [attr.id]="option.id"
            [attr.data-id]="option.id"
            afterCheckbox
        >
            <span class="ap-selector-modal__title" [attr.data-id]="option.id" data-testid="option-title">
                {{ option.title }}
                @if (option.subtitle) {
                    <span
                        [class.negative-amount]="option?.subtitle?.includes('-')"
                        class="ap-selector-modal__subtitle"
                        data-testid="option-subtitle"
                        [innerHTML]="option.subtitle"
                    ></span>
                }
            </span>
            <span class="ap-selector-modal__text" [attr.data-id]="option.id" data-testid="option-text">
                {{ option.text }}
            </span>
            @if (option.extra) {
                <span
                    class="ap-selector-modal__extra"
                    [attr.data-id]="option.id"
                    data-testid="option-extra"
                    [innerHTML]="option.extra"
                ></span>
            }
        </span>
    </ap-checkbox>
</ng-template>

<form [formGroup]="form" data-testid="form">
    @if (groups()) {
        @for (group of groups(); track i; let i = $index) {
            @if (getGroupOptions(group.id).length > 0) {
                <fieldset class="ap-selector-modal__group" role="group" data-testid="group">
                    @if (group.title) {
                        <legend class="ap-selector-modal__group__title" data-testid="group-title">
                            {{ group.title }}
                        </legend>
                    }
                    @for (option of getGroupOptions(group.id); track option.id) {
                        <ng-container [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{ $implicit: option }"> </ng-container>
                    }
                </fieldset>
            }
        }
    } @else {
        @for (option of optionsToDisplay(); track $index; let i = $index) {
            <ng-container [ngTemplateOutlet]="optionTemplate" [ngTemplateOutletContext]="{ $implicit: option }"> </ng-container>
        }
    }

    <ap-button
        class="ap-selector-modal__confirm-button"
        type="button"
        variant="primary"
        [wide]="true"
        (onClick)="select()"
        data-testid="confirm-button"
    >
        {{ 'selectorModalMultiple.confirm' | apContent: { amount: selectedOptions()?.length.toString() || '0' } }}
    </ap-button>
</form>
